import { render } from "./ChargeWallet.vue?vue&type=template&id=60fe72d0"
import script from "./ChargeWallet.vue?vue&type=script&lang=js"
export * from "./ChargeWallet.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/holdingalmas-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__